export default {
  namespace: 'user', // 注意定义namespace, 将会在store中存储
  state: {
    openId: '123',
    id: '',
    menu: [],
    invoiceModel: true, //  发票入口和提示总开关
    invoiceTime: 0  //  发票可开天数限制，0无提示
  },
  getters: {
    openId: state => state.openId,
    id: state => state.id
  },
  actions: {
    updateUserInfo ({commit, state}, payload) {
      commit('updateUserInfo', payload)
    }
  },
  mutations: {
    updateUserInfo (state, payload) {
      for (let prop in payload) {
        state[prop] = payload[prop]
      }
    },
    set_menu (state, payload) {
      state.menu = payload
    },
    ser_invoiceTime (state, time) {
      state.invoiceTime = time
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js